import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import { SingleDatePicker } from 'react-dates'
import { useEffect, useState } from 'react'
import { Box } from '@chakra-ui/react'

export default function DatesSubform({ setDate, prefilledDate }) {

    const [focused, setFocused] = useState(false)
    const [internalDate, setInternalDate] = useState(prefilledDate)

    useEffect(() => {
        setDate(internalDate)
    }, [internalDate])

    return (
        <>
            <Box
                position='relative'
                align='center' // TODO: Full width of container, tweak height
            >
                <SingleDatePicker
                    date={internalDate}
                    onDateChange={(date) => setInternalDate(date)} 
                    focused={focused}
                    onFocusChange={() => setFocused(!focused)}
                    id="date"

                    isOutsideRange={() => false}
                    firstDayOfWeek={1}
                    numberOfMonths={1}
                    showClearDate
                    displayFormat='DD/MM/yyyy'
                    hideKeyboardShortcutsPanel
                />
            </Box>
        </>
    )
}